<template lang="html">
  <div class="border-right" id="sidebar-wrapper">
    <div class="header-sidebar" slot="header">
      <img src="../../../assets/UNODC-logo-full.png" alt="" width="200" />
    </div>
    <div class="list-group list-group-flush mb-3">
      
      <router-link
        to="/dashboard/Advisor/advisordashboardView"
        class="list-group-item list-group-item-action"
      >
        <i class="material-icons">home</i> Dashboard
      </router-link>

      <router-link
        to="/dashboard/Advisor/advisordashboard"
        class="list-group-item list-group-item-action"
      >
        <i class="material-icons">folder</i> Explore Events
      </router-link>
      <router-link
        to="/dashboard/Advisor/conductedTraining"
        class="list-group-item list-group-item-action"
      >
        <i class="material-icons">assignment_turned_in</i> Assigned Events
        <span
          class="badge badge-danger pl-2 pr-2"
          style="font-size:14px"
          >{{Counter}}</span
        >
      </router-link>
      <div>
        <div
          slot="header"
          class="list-group-item list-group-item-action"
          id="mybutton"
        >
          <i class="material-icons pr-1">brightness_low</i
          ><b>Event Management</b>
        </div>

        <ul>
          <router-link
            to="/dashboard/Advisor/questionbankarchives"
            class="list-group-item list-group-item-action"
          >
            <i class="material-icons">remove</i> Question Bank
          </router-link>

          <router-link
            to="/dashboard/Advisor/KnowledgeBaseArchives"
            class="list-group-item list-group-item-action"
          >
            <i class="material-icons">remove</i> Knowledge Base
          </router-link>
        </ul>
      </div>
      <div>
        <div slot="header" class="list-group-item list-group-item-action" id="mybutton">
                <i class="material-icons pr-1">chrome_reader_mode</i><b>Reports</b>
            </div>
        <router-link
          to="/dashboard/Advisor/reportsAdvisorAll"
          class="list-group-item list-group-item-action"><i class="material-icons pr-1">remove</i>Brief Report
        </router-link>
        <router-link
          to="/dashboard/Advisor/TrainingsReportAdvisor"
          class="list-group-item list-group-item-action"
          ><i class="material-icons pr-1">remove</i>Events Report
        </router-link>
        <router-link to="/dashboard/Advisor/thematicAreaReport" class="list-group-item list-group-item-action"><i class="material-icons pr-1">remove</i>Thematic Area Report
        </router-link>
        <router-link to="/dashboard/Advisor/StaticsReportAdvisor" class="list-group-item list-group-item-action"><i class="material-icons pr-1">remove</i>Statistical Report
        </router-link>
        <router-link to="/dashboard/Advisor/analytics" class="list-group-item list-group-item-action"><i class="material-icons pr-1">remove</i>Deep Analytics
        </router-link>
      </div>
      <div @click="showAlert" class="version-container">
        <span class="version">UNODC Version {{ version }}</span
        ><br />
        <span class="rights"
          >&copy;{{this.currentYear}}. All Rights Reserved</span
        >
      </div>
    </div>

    <!-- Modal 
    <div class="modal2" v-if="showModal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div>
            <button type="button" class="close" @click="closeModal">
              &times;
            </button>
          </div>
          <div class="box-check-v">
            <i class="material-icons check-v"> check_circle_outline</i>
          </div>
          <div class="modal-version">UNODC Update Version {{ version }}</div>

          <div class="modal-body">
            <div v-html="htmlContent"></div>
            <div style="text-align: right;">
              <button
                @click="closeModal"
                style="background-color: #00a6e4; color: white; border: none;  padding: 5px 15px; border-radius: 4px;"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
     -->
  </div>
</template>

<script>
import { bus } from "../../../main";
import axios from "axios";
import Swal from 'sweetalert2';


export default {
  data: () => ({
    active: true,
    basepath: process.env.VUE_APP_BASE_PATH,
    Counter: 0,
    version: '',
    releaseDate: '',
    htmlContent: "",
    currentYear: new Date().getFullYear()

  }),
  created() {
    bus.$on("sidebarStatus", data => {
      this.active = data;
    });
  },
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    this.unassignedTrainingsCount();
    const token = localStorage.getItem('token');
        if (!token) {
            this.$toasted.global.errorMsg('Please login again');
            localStorage.clear();
            this.$router.push("/");
            return;
        }

        // Decode token to check expiration
        const tokenData = JSON.parse(atob(token.split('.')[1]));
        const tokenExpiration = tokenData.exp * 1000; // Convert to milliseconds
        const currentTime = Date.now();
        
        if (currentTime > tokenExpiration) {
            this.$toasted.global.errorMsg('Session expired. Please login again');
            localStorage.clear();
            this.$router.push("/");
            return;
        }

        axios.defaults.headers['Authorization'] = token;
        const appVersion = localStorage.getItem("version")
        const currentUser = JSON.parse(localStorage.getItem("currentUser"))
        const userId = currentUser.id

        axios
            .get("https://tmisodc.org/live_version.php")
            .then(response => {
                   this.version = response.data.version_no;
                  //  this.releaseDate = response.data.releaseDate;
                   this.htmlContent = response.data.html;
                         if(response.data.version_no != appVersion){
                  this.showAlert()
                  axios
                     .put(process.env.VUE_APP_BASE_PATH + "/users/update-version",{
                         userId: userId,
                         versionNo: response.data.version_no
                     })
                }   
                localStorage.setItem("version",response.data.version_no)
                 
            });
    },
  methods: {
    isSidebar() {
      bus.$emit("sidebarStatus", this.active);
    },
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    unassignedTrainingsCount: function unassignedTrainingsCount() {
      this.openLoading();
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/advisor/unassigned/count-training/" +
            JSON.parse(localStorage.getItem("currentUser")).id

        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response.data && response.data.unsignedTrainingCount) {
            this.Counter = response.data.unsignedTrainingCount;
          }
        });
    },
     showAlert() {
               Swal.fire({
                 title: `TMIS Updated To Version ${this.version}`,
                 html: `<div style="margin-top: 10px; border-bottom: 1px solid #cccccc; width: 100%;"></div>
                        <div>${this.htmlContent}</div>`,
                 icon: 'success',
                 showCloseButton: false,
                 showConfirmButton: true,
                 confirmButtonText: 'Close',
                 confirmButtonColor: '#00a6e4',
                 width: '50em',
                willOpen: () => {
                 const swalPopup = document.querySelector('.swal2-popup');
                     if (swalPopup) {
                           swalPopup.style.height = '700px';
                           swalPopup.style.overflowY = 'auto';
                         }

                  const swalBackdrop = document.querySelector('.swal2-container');
                    if (swalBackdrop) {
                        swalBackdrop.style.background = 'rgba(0, 0, 0, 0.7)';
                     }
                     const swalIcon = document.querySelector('.swal2-icon');
                     if (swalIcon) {
                         swalIcon.style.margin = '0.4em auto 0.5em';
                      }
                   }
                });
            }

  }
};
</script>

<style scoped>


body {
  overflow-x: hidden;
}

.material-icons {
  font-size: 20px !important;
  vertical-align: bottom;
}
#sidebar-wrapper {
  min-height: 100vh;
  margin-left: -15rem;
  -webkit-transition: margin 0.25s ease-out;
  -moz-transition: margin 0.25s ease-out;
  -o-transition: margin 0.25s ease-out;
  transition: margin 0.25s ease-out;
}

#sidebar-wrapper .sidebar-heading {
  padding: 0.875rem 1.25rem;
  font-size: 1.2rem;
}

#sidebar-wrapper .list-group {
  width: 15rem;
}

#page-content-wrapper {
  min-width: 100vw;
}

#wrapper.toggled #sidebar-wrapper {
  margin-left: 0;
}

@media (min-width: 768px) {
  #sidebar-wrapper {
    margin-left: 0;
  }

  #page-content-wrapper {
    min-width: 0;
    width: 100%;
  }

  #wrapper.toggled #sidebar-wrapper {
    margin-left: -15rem;
  }
}
/* scrollbar css starts */
/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgba(7, 167, 225);
  border-radius: 50px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgba(7, 167, 225);
}
/* scrollbar css ends */
.version-container {
   width: 240px;
  position: absolute;
  bottom: 2px;
  cursor: pointer;
  padding: 1px;
  text-align: center;
  max-width: 300px;
  margin: 0 auto;
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.version {
  font-weight: bold;
  font-size: 1em;
  color: #333;
}

.rights {
  font-size: 0.9em;
  color: #777;
}
/*
.modal2 {
    position: fixed;
    z-index: 99;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.7);
}
.modal-version{
  color: #00a6e4;
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 10px;
}
.check-v{
  font-size: 50px !important;
  color: #00a6e4;
}
.box-check-v{
  text-align: center;
}
.modal-body {
  border-top: 1px solid #bfbaba;
  height: 500px;
  overflow: auto;
}
*/
</style>
